import React from 'react';
import clsx from 'clsx';

export function DialogRow({ children, onClick }) {
    return (
        <div className="dialog-row" onClick={onClick}>
            {children}
        </div>
    );
}

export function DialogRowButton({ children, onClick, disabled, className = '', ...rest }) {
    return (
        <button className={`dialog-row-button ${className}`} onClick={onClick} disabled={disabled} {...rest}>
            {children}
        </button>
    );
}

export function DialogRowIcon({ className, children }) {
    return <div className={clsx('dialog-row-icon', className)}>{children}</div>;
}

export function DialogRowText({ children }) {
    return <span className="dialog-row-text">{children}</span>;
}
